import React, { Component } from 'react';
import { NavLink as Link } from 'react-router-dom';

class NavLink extends Component {
    render() {
        return (
            <li><Link to='/home'><i className="fa fa-dashboard" /> <span>Dashboard</span></Link></li>
        );
    }
}

export default NavLink;


// WEBPACK FOOTER //
// ./src/Components/Navigation/NavLink.js